import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How a book I wrote in two weeks made $4,000 in its first month",
  "description": "",
  "published": "2015-05-01T00:00:00.000Z",
  "redirect_from": ["/blog/how-a-book-i-wrote-in-two-weeks-made-4000-in-its-first-month/swizec/6675"],
  "categories": "Business, Conversion rate, Landing page, Learning, Marketing, Side Projects",
  "hero": "./img/images-28694.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/4ab94e9bfddd048237825ab8889f78a8/776d3/images-28694.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.50224215246637%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'227\\'%20viewBox=\\'0%200%20400%20227\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M160%206l-1%203c0%202%200%202%209%202%208%200%209%200%208-2h1c2%202%202%202%203%201h1l5%201c3%200%205%200%204-1l-1-2c-1-3-4-3-6-2l-6%201h-14l-3-1m213%2033a2217%202217%200%2001-110%207c-3%201-7%202-21%202-15%201-20%201-28%204l-19%203c-16%201-25%204-29%208-8%206-43%2018-55%2018-2%200-5%203-13%209-5%206-11%2011-13%2012l-8%209-9%2011c-6%204-12%2014-18%2028-6%2015-12%2024-17%2027-4%203-14%2017-14%2020%200%202%202-1%206-8%203-5%205-8%209-10%205-4%2012-14%2018-28%205-14%2012-24%2017-28l9-10%208-10%2013-11%2012-9c12%200%2047-12%2056-19%205-4%2010-5%2028-7l17-3c9-3%2021-4%2035-4%2010%200%2013%200%2016-2a2682%202682%200%2000110-9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ab94e9bfddd048237825ab8889f78a8/ca0a1/images-28694.webp 223w", "/static/4ab94e9bfddd048237825ab8889f78a8/75680/images-28694.webp 445w", "/static/4ab94e9bfddd048237825ab8889f78a8/8d1ba/images-28694.webp 890w", "/static/4ab94e9bfddd048237825ab8889f78a8/3838e/images-28694.webp 1335w", "/static/4ab94e9bfddd048237825ab8889f78a8/e11e5/images-28694.webp 1780w", "/static/4ab94e9bfddd048237825ab8889f78a8/dcb16/images-28694.webp 1814w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4ab94e9bfddd048237825ab8889f78a8/e92b6/images-28694.png 223w", "/static/4ab94e9bfddd048237825ab8889f78a8/e66bf/images-28694.png 445w", "/static/4ab94e9bfddd048237825ab8889f78a8/4ef49/images-28694.png 890w", "/static/4ab94e9bfddd048237825ab8889f78a8/4e814/images-28694.png 1335w", "/static/4ab94e9bfddd048237825ab8889f78a8/701e9/images-28694.png 1780w", "/static/4ab94e9bfddd048237825ab8889f78a8/776d3/images-28694.png 1814w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4ab94e9bfddd048237825ab8889f78a8/4ef49/images-28694.png",
                "alt": "React+d3.js total revenue",
                "title": "React+d3.js total revenue",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`React+d3.js total revenue`}</figcaption>{`
  `}</figure><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`It all started with a challenge from a friend.`}</p>
    <p><em parentName="p">{`"You know, you should self-publish a book on React and d3.js. I want to see if it's useful."`}</em></p>
    <p><em parentName="p">{`"I don't know man, I've got a lot going on ... "`}</em></p>
    <p><em parentName="p">{`"If it's important enough, you'll find the time :)"`}</em></p>
    <p><em parentName="p">{`"Fuck you man, I'll do it in two weekends!"`}</em></p>
    <p>{`Five weeks later `}<a parentName="p" {...{
        "href": "http://swizec.com/reactd3js"
      }}>{`React+d3.js`}</a>{` was launched. A 63 page book that shows you how to build interactive data visualization components with React and d3.js.`}</p>
    <p>{`In the month and a half since launch, it sold 329 copies, made $4,022 in revenue and some $3,000 in pure profits if you don't count my time. With an effective hourly rate of $40/hour it has more than surpassed either of my two other books.`}</p>
    <p>{`My friend may have won the bet, but I learned a lot.`}</p>
    <h2 {...{
      "id": "some-things-that-worked-before-launch"
    }}>{`Some things that worked before launch`}</h2>
    <p>{`Two weeks before launch the example my book would be based on was complete. It had taken me two weeks to learn React and find a good way to marry it with d3.js to produce a shiny visualisation.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1fd69d10ab4cf682003f454bddf89270/cb93d/images-28692.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.399103139013455%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'230\\'%20viewBox=\\'0%200%20400%20230\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M77%204c0%202%200%202-2%201-1-2-4-1-4%202h-1V6c0-1-3-2-4-1v3l-1%201%206%201c4%200%205-1%206-2%200-2%200-2%201%200s1%202%201%200c0-3%202-3%202%200l1%202%201-2V6l1%202c1%202%203%203%203%201h1c1%202%203%200%203-3%200-2%200-2-1-1-1%202-1%202-1%200h-4l-3-1-2-1c0-2-2-1-3%201m155-1l-2%201-2%203c-1%202-1%202-1%200%200-4-4-4-4-1v3l-1-3c-2-3-8-3-9%201l1%203%201-2c0-3%202-3%202%200l1%203V8c0-2%202-3%202%200%200%201%201%202%207%202l7-1h1c1%202%204%201%205-2%200-3-3-4-5-1-1%201-1%201-1-1l-1-3-1%201M131%207c0%203%200%203%201%201%200-3%202-3%202%200l1%202%201-1h1c1%201%2010%201%2010-1h1c0%203%202%202%202%200l1-2%201%202%202%202c2%200%204-2%202-3V6l1-1h-19l-2%201c-2-4-5-2-5%201M31%2060v4h17v-8H31v4m0%2030v8h34v-8H36l1-4c0-4%200-4-3-4h-3v8m0%2013v3h111v-7H31v4m0%2012v8h145v-7l-17-1h-16v-8H31v8m0%2017v8h94v-4l1-4c2%200%202-1%202-4v-4H31v8m0%2018c0%209%201%2011%202%2010l1%201-1%201-2%202%205%201h4v-8h12v-4l-1-4h19v-8H31v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1fd69d10ab4cf682003f454bddf89270/ca0a1/images-28692.webp 223w", "/static/1fd69d10ab4cf682003f454bddf89270/75680/images-28692.webp 445w", "/static/1fd69d10ab4cf682003f454bddf89270/8d1ba/images-28692.webp 890w", "/static/1fd69d10ab4cf682003f454bddf89270/3838e/images-28692.webp 1335w", "/static/1fd69d10ab4cf682003f454bddf89270/e11e5/images-28692.webp 1780w", "/static/1fd69d10ab4cf682003f454bddf89270/b4689/images-28692.webp 2304w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1fd69d10ab4cf682003f454bddf89270/e92b6/images-28692.png 223w", "/static/1fd69d10ab4cf682003f454bddf89270/e66bf/images-28692.png 445w", "/static/1fd69d10ab4cf682003f454bddf89270/4ef49/images-28692.png 890w", "/static/1fd69d10ab4cf682003f454bddf89270/4e814/images-28692.png 1335w", "/static/1fd69d10ab4cf682003f454bddf89270/701e9/images-28692.png 1780w", "/static/1fd69d10ab4cf682003f454bddf89270/cb93d/images-28692.png 2304w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1fd69d10ab4cf682003f454bddf89270/4ef49/images-28692.png",
                "alt": "H1B histogram made with React and d3.js",
                "title": "H1B histogram made with React and d3.js",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`H1B histogram made with React and d3.js`}</figcaption>{`
  `}</figure></p>
    <p>{`That graph was seen by 40,000 people in the first week. It stayed on first place of `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`Hacker News`}</a>{` for over a day and made it as far as Slashdot. Yeah, Slashdot still exist, who woulda thunk it ...`}</p>
    <p>{`It isn't the sexiest graph out there, but it does show some cool features of React. Whenever you click a button everything changes. The graph, the description, the title, everything.`}</p>
    <p>{`This got people excited about what's possible and some of them signed up to learn about the book.`}</p>
    <p>{`When the book was done two weeks later, I had a mailing list of about 180 people. Graph->signup conversion rate, 0.45%. Half a percent, not `}<em parentName="p">{`too`}</em>{` shabby.`}</p>
    <p>{`I told the mailing list that the book was done and promised a free copy to everyone who wants to read the draft and give me feedback. 20 people raised their hand. Email->test reader conversion rate, ~11%.`}</p>
    <p>{`Of those twenty people, four or five came back with feedback early enough for me to act before hitting the launch line in the sand. Not only was this early feedback invaluable in improving the book, but it gave me some great reader testimonials to put on the landing page.`}</p>
    <p>{`Handraise->feedback conversion rate, ~25%.`}</p>
    <h2 {...{
      "id": "some-things-that-worked-after-launch"
    }}>{`Some things that worked after launch`}</h2>
    <p>{`I launched the book on a Monday. Evening European time, morning-ish Pacific.`}</p>
    <p>{`The email went out to my mailing list immediately. Sales started instantly. I sold 30 packages that first day. 35 the next. Then sales per day started falling.`}</p>
    <p>{`Right now it's selling about three copies a day with organic traffic. But I have to work on that.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "700px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/57c914e54c2b8bda0b9c92a6fa48d16d/8c557/images-28696.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'240\\'%20viewBox=\\'0%200%20400%20240\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M172%209c0%203%200%203%201%202h1l8%201c8%200%209-1%208-2h2c1%202%202%202%202%201h1l6%201%205%201c0%202%206-2%205-4l-2-2h-1l-1-1-1%201v2c0%202-2%201-2-1s-5-2-7-1c-2%202-3%202-3%201h-10l-5-1h-4c-1-2-3-1-3%202m-13%2030l-5%2077-4%2072-4%205-9%209-5%205-4-4-4-5-5%202-4%203-4-12c-4-11-11-23-14-23l-4%207-5%205-5-13c-4-13-4-15-6-11l-4%209-3%207-4-4c-4-4-4-3-11-27l-3-7-4%2020-5%2021c-1%202-8-9-8-13A10011%2010011%200%200125%2045l-9%2025%204-10%205-9a5421%205421%200%200110%20116l9%2013%204-19c4-23%204-23%205-21l4%2013c3%2010%204%2012%208%2017l5%205%204-9%205-9%204%2013%205%2014%205-6%204-7c3%200%209%2010%2013%2022l4%2012%205-3%204-2%205%204%205%205c3-1%2018-20%2018-22a5242%205242%200%20009-150l4%204%204%205%204%2058%204%2059%205%2016c5%2016%2013%2035%2015%2035%202-1%209-10%2013-17%204-6%206-9%209-10l4-2%205%205%209%207c3%202%205%204%208%2010l4%207h11l4-6%204-7%204%207c5%207%204%207%2010%204%204-3%205-3%2027-3h23l4-5%203-4%205%205%205%204%204-2c4-2%206-4%209-9l4-7%205%207c5%208%2012%2016%2014%2016l9-11-5%205-4%204-4-4-9-12-6-8-5%208c-3%206-5%208-8%2010l-4%201-5-4-5-5-4%205-4%205h-23c-20%200-22%200-26%202-5%203-5%203-10-5l-4-7-5%208c-4%207-5%207-9%207s-4%200-8-7c-3-6-5-8-9-10l-9-8-5-5-5%203c-3%202-6%204-9%2010l-12%2016c-2-2-10-21-13-33l-5-15-4-59-5-60-5-6-5-5v5M41%20118l-1%202h-1c0%202%208%201%208-1h1l2%202%201-2%201%201c1%202%204%202%204-1l1%201c1%201%201%202%202%201h4l3-1%201-2%201%201c0%203%202%204%204%202l3-1c1%201%201%200%201-2s0-3-1-2h-7l-7%201h-6a48%2048%200%2001-10%200l-2-1-1-1-1%203m20%208h-1l-2%201H46l1%203h6l2%201h7c4%200%205%200%205-2h1v3c-1%202%201%201%203-2v-3h-3l-3-1h-2l-1-1-1%201m33%2019h-1l-2%201H80c-2-2-2%200-1%203h15c0%202%206%201%206-1%201-1%201%200%201%201v3l3-6h-3c-2-2-2-2-3-1h-2l-1-1-1%201m5%2017c-3%202%201%207%203%205h12l1-2h1c0%202%205%203%205%201l1-2%201%202%201%201h1c0%202%202%203%203%201h3c2%200%203-1%203-3%202-2%203-3%203%200l-1%201v1h4v2l1-1%202-1c2%201%203%200%202-3-1-2-1-2-4-1-1%201-2%201-2-1h-5l-2-1-3%201-1%201h-7c-2%201-5%200-6-1h-3l-2%201h-3c-1-1-1-1-2%201l-1-1c-1-2-4-3-5-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/57c914e54c2b8bda0b9c92a6fa48d16d/ca0a1/images-28696.webp 223w", "/static/57c914e54c2b8bda0b9c92a6fa48d16d/75680/images-28696.webp 445w", "/static/57c914e54c2b8bda0b9c92a6fa48d16d/426ac/images-28696.webp 700w"],
                "sizes": "(max-width: 700px) 100vw, 700px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/57c914e54c2b8bda0b9c92a6fa48d16d/e92b6/images-28696.png 223w", "/static/57c914e54c2b8bda0b9c92a6fa48d16d/e66bf/images-28696.png 445w", "/static/57c914e54c2b8bda0b9c92a6fa48d16d/8c557/images-28696.png 700w"],
                "sizes": "(max-width: 700px) 100vw, 700px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/57c914e54c2b8bda0b9c92a6fa48d16d/8c557/images-28696.png",
                "alt": "React+d3.js sales",
                "title": "React+d3.js sales",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`React+d3.js sales`}</figcaption>{`
  `}</figure></p>
    <p>{`A day after launch I made a new landing page. Bought a theme that looks like one of those converty book landing page things and modified it. Took four or five hours, but I'm really happy with it.`}</p>
    <p>{`Maybe I'm weird, but I love those long sales pages because they give me enough time to explain why the book is worth your time and money. And if you can't even be bothered to read a 500 word landing page, you won't read the 7000 word book either.`}</p>
    <p>{`The landing page conversion rate is 3% session->$$ and 4.8% session->sale (the super basic package is free for reasons). I'm told those conversion rates are really good, but I calculated them naively so I'm not sure if they're super accurate.`}</p>
    <p>{`Asking a few popular mailing lists to include me in their email proved fruitful as well. Javascript Weekly converted into about $600 worth of sales. HTML5 Weekly performed a bit less well, followed by DashingD3.js.`}</p>
    <p>{`Another big win was bundling with the incredibly popular D3 Tips and Tricks. Most of my sales these days come straight from being bundled with that book and the initial email blast to 18,000 readers produced as many sales as the launch did.`}</p>
    <p>{`But the caveat of that deal was introducing a free tier with just the pdf. @d3noob is an idealist and thinks knowledge should be free. Which is kind of true, but it was well worth tweaking the parameters of my experiment for.`}</p>
    <p>{`In terms of profit, tiered pricing worked great. The basic package with just the book and a bit of code has made $2,082 in revenue with 296 sales. The Premium and Team packages combined made $1,939 on just 33 sales between them.`}</p>
    <p>{`So far nobody has bought the full platinum package.`}</p>
    <h2 {...{
      "id": "some-things-that-failed"
    }}>{`Some things that failed`}</h2>
    <p>{`My biggest fail was asking those early supporters whose email addresses I had to upvote my Show HN post. This worked great with some 18 upvotes in the first twenty minutes.`}</p>
    <p>{`But it worked too well. The post got flagged into oblivion and sank further with every upvote. One subscriber even complained that it's really not kosher of me to ask for upvotes.`}</p>
    <p>{`And he's right. And the post must have gotten as many flags as it did upvotes.`}</p>
    <p>{`That was a fail on my part. Should have trusted the book to make it on its own merits. Considering how much traffic Hacker News produces, this mistake cost me $10,000++.`}</p>
    <p>{`Oops.`}</p>
    <p>{`Another silly mistake was giving early readers a bigger discount than I intended to. I promised 25% and gave 50% because I had assumed Leanpub's pay-what-you-want sliders work with coupons as well. They don't.`}</p>
    <p>{`Oops. But happier readers so that's okay.`}</p>
    <p>{`A really really huge fail on my part was providing a crappy video with the Premium package. It was supposed to be a sexy hour-long screencast showing how everything fits together.`}</p>
    <p>{`But I ran out of time and launched before it was done. I promised to get it done in a week or so.`}</p>
    <p>{`Then I got sick for a week. Then I found out I suck at video editing. Then `}<a parentName="p" {...{
        "href": "http://www.packtpub.com",
        "title": "Packt"
      }}>{`Packt`}</a>{` blindsided me with a tight deadline on a d3.js video course that's about to launch.`}</p>
    <p>{`A month later and still no good video. But production is starting again and this time around I have an awesome freelancer to do the editing for me.`}</p>
    <p>{`But I launched and I learned my lesson. Delegate the things you suck at!`}</p>
    <p>{`Somewhat of a fail but not too bad was launching a better landing page the day after launch launch. It's not too bad, but I think it converts better and it would just be more consistent. Especially with the whole attempt at HN publicity and such.`}</p>
    <p>{`But at least all those mailing lists got the better landing page so that's good.`}</p>
    <p>{`Another fail was that I didn't write those guestposts I had arranged. Four people promised to publish my guest post about React and d3.js on their website. This would be awesome for publicity and driving traffic to the book. But things happened and I haven't gotten around to writing them.`}</p>
    <p>{`I'll write them now and hope everyone's still willing to publish. Next time, I will have those opportunities arranged before launch `}<em parentName="p">{`and`}</em>{` write the posts before launch as well. That way a bigger press push can happen on launch.`}</p>
    <p>{`And I think I didn't tweak the tiered pricing well enough. The incentive to pick a higher tier package isn't big enough. Something to think about.`}</p>
    <h2 {...{
      "id": "things-left-to-try"
    }}>{`Things left to try`}</h2>
    <p>{`All in all this has been a great experiment.`}</p>
    <p>{`My initial line in the sand for success was $1,000 in revenue. The book made 4x more. o/`}</p>
    <p>{`The second line in the sand, reaching 10k before end of April didn't happen. Mostly because I was too busy with the Packt deadline on that video course project.`}</p>
    <p>{`A few things I'm going to try so I can get the 10k milestone in May:`}</p>
    <ul>
      <li parentName="ul">{`set up a drip campaign for the book`}</li>
      <li parentName="ul">{`a system to check-in with readers a week or two after buying to get feedback and ensure they liked it (happy readers tell their friends)`}</li>
      <li parentName="ul">{`play with advertising`}</li>
    </ul>
    <p>{`But the biggest experiment to try is seeing if I can turn this into a system. Learn a tech, write about tech, launch book, once a month or every two months. Produce enough income to live off of.`}</p>
    <p>{`That's the ultimate experiment right there.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      